// test1121
(1121 && 0);
